/** Список полей */
const columnDataGrid = [
  {
    dataField: 'modDateTime',
    dataType: 'datetime',
    caption: 'Время отправки'
  },
  {
    dataField: 'subject',
    dataType: 'string',
    caption: 'Тема'
  },
  {
    dataField: 'destinationEmail',
    dataType: 'string',
    caption: 'Получатель'
  },
  {
    dataField: 'senderEmail',
    dataType: 'string',
    caption: 'Отправитель'
  },
  {
    dataField: 'body',
    dataType: 'string',
    caption: 'Тело сообщения',
    cssClass: 'dx-header-row.td-button-cell-render'
  },
  {
    dataField: 'attachments',
    dataType: 'string',
    caption: 'Вложения'
  },
  {
    dataField: 'modUser',
    dataType: 'string',
    caption: 'ФИО пользователя'
  },
  {
    dataField: 'status',
    dataType: 'string',
    caption: 'Статус отправки'
  },
  {
    dataField: 'error',
    dataType: 'string',
    caption: 'Ошибка'
  }
];

export default columnDataGrid;
